import React from 'react';
import Loader from '../UI/Loader/Loader';
import { Formik, Form } from 'formik';
import { TargetOfferSchema } from '../../schemas';
import PrimaryModal from '../UI/Modal/PrimaryModal';
import { FormikInput, PrimaryButton } from "../UI";
import { useUserContext } from '../../contexts/UserContext';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const CreateOfferModal = ({ hideCreateOfferModal, offerSuccessMessage, loading, handleSubmit, error }) => {
    const { userData } = useUserContext();
    const { content } = useContentfulContext();

    return (
        <PrimaryModal title="Create Adobe Target Offer" hideModal={hideCreateOfferModal}>
            <div className='p-6 space-y-6'>
                {loading && <Loader />}
                <div>
                    <Formik
                        initialValues={{
                            offer_name: ''
                        }}
                        validationSchema={TargetOfferSchema}
                        onSubmit={handleSubmit}
                    >
                        {() => (
                            <Form className="space-y-4 md:space-y-6" action="#" id="target-form">
                                <p>The offer will be created in {userData.defaultWorkspace?.workspace_name} Workspace</p>
                                <FormikInput
                                    type="text"
                                    id="offer_name"
                                    name="offer_name"
                                    label="Enter Offer name"
                                    mandatory
                                />
                                {error && <p className="text-base leading-tight tracking-tight text-red-500 mb-4">{error}</p>}
                                <div className="flex items-center justify-end space-x-2">
                                    <PrimaryButton type="submit">{content.CREATE_OFFER_MODAL_CONTENT.submit_cta}</PrimaryButton>
                                </div>
                            </Form>
                        )}
                    </Formik>
                    <p className="mt-2 text-sm text-[#27942B]">{offerSuccessMessage}</p>
                </div>
            </div>
        </PrimaryModal>
    );
};

export default CreateOfferModal;